import React from 'react';
import ToolsCard from '../ToolsCard/ToolsCard';
import './ToolsSection.scss';

export default function ToolsSection({ icon, heading, description, cards }) {
  return (
    <section className='tools-section'>
      <div className='section-header'>
        <div className='heading-container'>
          <div className='section-icon-container'>
            <img src={icon} alt={heading} />
          </div>
          <h2>{heading}</h2>
        </div>
        <p>{description}</p>
      </div>
      <div className='cards-grid'>
        {cards.map((card, index) => (
          <ToolsCard
            key={index}
            icon={card.icon}
            title={card.title}
            description={card.description}
          />
        ))}
      </div>
    </section>
  );
}
